var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.2064 11.1474L15.0331 13.9512C15.3185 14.2465 15.3185 14.7149 15.0331 15.0102C14.89 15.1545 14.6953 15.2356 14.4921 15.2356C14.289 15.2356 14.0942 15.1545 13.9512 15.0102L11.1474 12.2064C8.30671 14.4847 4.18072 14.1453 1.75052 11.4335C-0.679672 8.72166 -0.566431 4.58328 2.00842 2.00842C4.58328 -0.566431 8.72166 -0.679672 11.4335 1.75052C14.1453 4.18072 14.4847 8.30671 12.2064 11.1474ZM1.53975 6.87308C1.53975 9.8186 3.92756 12.2064 6.87308 12.2064C8.28757 12.2064 9.64412 11.6445 10.6443 10.6443C11.6445 9.64412 12.2064 8.28757 12.2064 6.87308C12.2064 3.92756 9.8186 1.53975 6.87308 1.53975C3.92756 1.53975 1.53975 3.92756 1.53975 6.87308Z","fill":"#968B9D"}));
}

Search.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Search;

Search.default = Search;
